<app-alerts />

@if (form$ | async; as form) {
  <app-admin-brand-banner-details-form
    [data]="form"
    (submitClickEvent)="handleSubmitClickEvent($event)" />
} @else {
  <app-spinner-filled />
}
